import classNames from "components/ui/classNames";
import Link from "next/link";
import { SearchStateConsumer } from "../../lib/algolia/SearchStateContext";
import type { IAssetType } from "../../types/graphqlTypes";
import { encodeSearchState, withSelectedIndustrySector } from "../screener/searchState";

interface IIndustrySectorProps {
  assetType: IAssetType;
  industrySector: string;
  className?: string;
}

export default function IndustrySector({ assetType, industrySector, className }: IIndustrySectorProps) {
  const searchState = withSelectedIndustrySector(assetType, industrySector);
  const encodedSearchState = encodeSearchState(searchState);

  return (
    <SearchStateConsumer>
      {({ setSearchState }) => (
        <Link
          href={`/?searchState=${encodedSearchState}`}
          title={industrySector}
          onClick={() => setSearchState(searchState)}
          className={classNames(
            "text-blue font-aeonik text-sm font-bold text-blue-600 no-underline hover:underline",
            className,
          )}
        >
          {industrySector}
        </Link>
      )}
    </SearchStateConsumer>
  );
}
